import { Component, OnInit } from '@angular/core';
import { TRCAdminConfig } from '../../model/trc-admin-config.model';
import { TRCAdminConfigService} from '../../services/trc-admin-config.service';

@Component({
    selector: 'jhi-trc-admin-config',
    templateUrl: './trc-admin-config.component.html',
    styleUrls: ['./trc-admin-config.component.scss']
})
export class TRCAdminConfigComponent implements OnInit {

    public adminConfig: TRCAdminConfig;

    private code = 'message_bandeau';

    constructor(private configService: TRCAdminConfigService) {}

    ngOnInit() {
        this.configService.getConfigByCode(this.code).subscribe((adminConfig) => {
            this.adminConfig = adminConfig;
        })
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/trc-admin-config/trc-admin-config.component.ts